module.exports = __webpack_public_path__ + "static/media/SendMoney.eaf60b16.svg";